import { ConfiguratorService, HideObjectsCommand, FilterOperators } from '@/services/sketchfab/index';
import { ConfiguratorDefinition, ProductDefinition } from '@/models/configurator';
import * as _ from 'lodash';
import { IConfiguratorConfig, IAssemblyConfig, IRoomConfiguratorConfig } from '@/models/config';
import { FamilyDefinition } from '../models/configuratorx/configuratorSchema';

interface IStore {
  debug: boolean;
  services: any;
  state: {
    isMobile:boolean,
    family: any;
    product: any;
    selection: any;
    assemblyConfig: IAssemblyConfig;
    configuratorConfig: IConfiguratorConfig;
  };
  roomState: {
    room: any;
    selection: any;
    roomConfiguratorConfig: IRoomConfiguratorConfig;
  };
}

const storeInstance: IStore = {
  debug: true,
  services: {

  },
  state: {
    isMobile:false,
    family: null,
    product: null,
    selection: null,
    assemblyConfig: null,
    configuratorConfig: null,

  },
  roomState: {
    room: null,
    selection: null,
    roomConfiguratorConfig: null,
  },
};

export const Store = {
  ...storeInstance,
  setConfiguratorService(sketchfabId: string, service: ConfiguratorService) {
    storeInstance.services[sketchfabId] = service;
  },
  getConfiguratorService(sketchfabId: string): ConfiguratorService {
    return storeInstance.services[sketchfabId];
  },
  getProductsByFamilyId(familyId: string) {
    if (familyId) {
      const family = storeInstance.state.configuratorConfig.definitions.families.find(x => x.id === familyId);
      if (family) {

        return family.products;
      }

    }
    return [];
  },
  getFamilyById(id: string) {
    if (id) {
      const family = storeInstance.state.configuratorConfig.definitions.families.find(x => x.id === id);
      if (family) {

        return family;
      }

    }
    return null;
  },

  getProductById(id: string) {
    let product = null;
    if (id) {

      storeInstance.state.configuratorConfig.definitions.families.forEach((x) => {
        if (x.products.find(pro => pro.id === id)) {
          product = x.products.find(pro => pro.id === id);
        }
      });
    }
    return product;
  },
};




// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/store/index.ts